import { lazy } from 'react';
import {
  BarChartOutlined,
  BgColorsOutlined,
  EditOutlined,
  FormOutlined,
  HighlightOutlined
} from '@ant-design/icons';
import { AppRouter } from '@tools/ui/types';

const prefixPath = '/gaya';

const EscalateView = lazy(
  () =>
    import(
      /* webpackChunkName: "GayaRoutes" */ '../pages/Escalate/EscalateView'
    )
);

const SelectView = lazy(
  () =>
    import(
      /* webpackChunkName: "GayaRoutes" */ '../pages/Escalate/components/SelectView'
    )
);

const SurveyContainer = lazy(
  () =>
    import(
      /* webpackChunkName: "GayaRoutes" */ '../pages/Escalate/components/SurveyContainer'
    )
);

const ThemeEditorView = lazy(
  () =>
    import(
      /* webpackChunkName: "GayaRoutes" */ '../pages/ThemeCreator/ThemeView'
    )
);

const EditorView = lazy(
  () =>
    import(/* webpackChunkName: "GayaRoutes" */ '../pages/Editor/EditorView')
);

const DashboardView = lazy(
  () =>
    import(
      /* webpackChunkName: "GayaRoutes" */ '../pages/Dashboard/DashboardView'
    )
);

export const gayaRoutes: AppRouter = {
  modules: [
    {
      redirectFrom: [prefixPath, `${prefixPath}/*`]
    },
    {
      name: 'Theme editor',
      path: `${prefixPath}/theme/edit`,
      pages: [],
      component: ThemeEditorView,
      icon: BgColorsOutlined
    },
    {
      name: 'Editor (internal)',
      path: `${prefixPath}/editor/internal`,
      pages: [],
      component: EditorView,
      icon: HighlightOutlined
    },
    {
      name: 'Editor (external)',
      path: `${prefixPath}/editor/external`,
      pages: [],
      component: EditorView,
      icon: EditOutlined
    },
    {
      name: 'Escalate',
      path: `${prefixPath}/escalate`,
      pages: [
        {
          name: 'Select form',
          path: ``,
          exact: true,
          component: SelectView,
          tabs: []
        },
        {
          name: 'Form',
          path: `/:survey`,
          component: SurveyContainer,
          tabs: []
        }
      ],
      component: EscalateView,
      icon: FormOutlined
    },
    {
      name: 'Dashboard',
      path: `${prefixPath}/dashboard`,
      pages: [],
      component: DashboardView,
      icon: BarChartOutlined
    }
  ]
};
